import Swal from "sweetalert2";
import { apiV2, errorHandler } from "./index";
import {
  API_ERROR,
  FETCH_ATTRIBUTION_OPTIONS,
  FETCH_ATTRIBUTION_OPTIONS_START,
  FETCH_ATTRIBUTION_OPTIONS_ERROR,
  CREATE_ATTRIBUTION_OPTION,
  UPDATE_ATTRIBUTION_OPTION,
  DELETE_ATTRIBUTION_OPTION,
} from "../constants/ActionTypes";

// OS numeric identifiers used by the API (match App\Enum\OSType on APIv2).
// Source of truth lives in constants/attributionOs.js so the reducer can
// read them without forming a circular dep on this actions module.
// Re-exported here so existing imports from `actions/attributionOptionsActions`
// keep working.
import { OS_IOS, OS_ANDROID, OS_WEB_APP } from "../constants/attributionOs";
export { OS_IOS, OS_ANDROID, OS_WEB_APP };

export const OS_LABELS = {
  [OS_IOS]: "iOS",
  [OS_ANDROID]: "Android",
  [OS_WEB_APP]: "Web App",
};

export function fetchAttributionOptions() {
  return function (dispatch) {
    dispatch({ type: FETCH_ATTRIBUTION_OPTIONS_START });

    return apiV2.get('/attribution-options')
      .then((response) => {
        dispatch({
          type: FETCH_ATTRIBUTION_OPTIONS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_ATTRIBUTION_OPTIONS_ERROR });
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function createAttributionOption({ value, os }) {
  return function (dispatch) {
    return apiV2.post('/attribution-options', { value, os })
      .then((response) => {
        dispatch({
          type: CREATE_ATTRIBUTION_OPTION,
          payload: response.data,
        });
        Swal.fire({
          icon: "success",
          title: "Option created!",
          timer: 1000,
        });
        return response.data;
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: error.response?.data?.message || "Error creating option",
          heightAuto: true,
        });
        throw error;
      });
  };
}

export function updateAttributionOption(id, { value, os }) {
  return function (dispatch) {
    const payload = {};
    if (value !== undefined) payload.value = value;
    if (os !== undefined) payload.os = os;

    return apiV2.put(`/attribution-options/${id}`, payload)
      .then((response) => {
        dispatch({
          type: UPDATE_ATTRIBUTION_OPTION,
          payload: response.data,
        });
        Swal.fire({
          icon: "success",
          title: "Saved!",
          timer: 1000,
        });
        return response.data;
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: error.response?.data?.message || "Error saving option",
          heightAuto: true,
        });
        throw error;
      });
  };
}

export function deleteAttributionOption(id, os) {
  return function (dispatch) {
    return apiV2.delete(`/attribution-options/${id}`)
      .then(() => {
        dispatch({
          type: DELETE_ATTRIBUTION_OPTION,
          payload: { id, os },
        });
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          timer: 1000,
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: error.response?.data?.message || "Error deleting option",
          heightAuto: true,
        });
        throw error;
      });
  };
}
